import { ENRICHMENT_ANSWER_TYPE_OPTIONS } from "../enrichmentAnswerTypes";

export function isEnrichmentAnswerTypeOptions(enrichment) {
    return enrichment.answer_type == ENRICHMENT_ANSWER_TYPE_OPTIONS;
}
